export enum FeaturesRequest {
  AUTH = 'AUTH',
  SYSTEM = 'SYSTEM',
  CLARITY = 'CLARITY',
  ANALYTICS = 'ANALYTICS',
}
